import { defineMessages } from 'react-intl';

export default defineMessages({
    accountSummary: {
        id: 'portal.views.home-page-layout.Account Summary',
        defaultMessage: 'Account Summary',
    },
    myBalance: {
        id: 'portal.directives.templates.billing-summary-tiles.My Balance',
        defaultMessage: 'My Balance',
    },
    overdue: {
        id: 'portal.directives.templates.billing-summary-tiles.Overdue',
        defaultMessage: 'Overdue',
    },
    payNow: {
        id: 'portal.directives.templates.billing-summary-tiles.Pay Now',
        defaultMessage: 'Pay Now',
    },
    myNextBill: {
        id: 'portal.directives.templates.billing-summary-tiles.My Next Bill',
        defaultMessage: 'My Next Bill'
    },
    due: {
        id: 'portal.directives.templates.billing-summary-tiles.Due',
        defaultMessage: 'Due',
    },
    updateMyDetails: {
        id: 'portal.views.home-page-layout.Update My Details',
        defaultMessage: 'Update My Details'
    },
    lastPayment: {
        id: 'portal.directives.templates.billing-summary-tiles.My Last Payment',
        defaultMessage: 'My Last Payment',
    },
    paid: {
        id: 'portal.directives.templates.billing-summary-tiles.Paid',
        defaultMessage: 'Paid',
    },
    renewalInfo: {
        id: 'portal.views.home-page-layout.You have policies due for renewal.',
        defaultMessage: 'You have policies due for renewal.'
    },
    policies: {
        id: 'portal.views.home-page-layout.Policies',
        defaultMessage: 'My Policies'
    },
    myAgentInfo: {
        id: 'portal.views.home-page-layout.MyAgentInfo',
        defaultMessage: 'My Agent Information'
    },
    policyEmpty: {
        id: 'portal.views.home-page-layout.PolicyEmpty',
        defaultMessage: 'Policies are not yet attached to this account'
    },
    claimEmpty: {
        id: 'portal.views.home-page-layout.ClaimEmpty',
        defaultMessage: 'Claims are not assosiated to this account'
    },
    billingEmpty: {
        id: 'portal.views.home-page-layout.BillingEmpty',
        defaultMessage: 'Billing Details are not assosiated to this account'
    },
    policyNumber: {
        id: 'portal.views.home-page-layout.PolicyNumber',
        defaultMessage: 'Policy Number'
    },
    policyStatus: {
        id: 'portal.views.home-page-layout.PolicyStatus',
        defaultMessage: 'Status'
    },
    policyEffectiveDate: {
        id: 'portal.views.home-page-layout.PolicyEffectiveDate',
        defaultMessage: 'Effective Date'
    },
    policyExpiryDate: {
        id: 'portal.views.home-page-layout.PolicyExpiryDate',
        defaultMessage: 'Expiry Date'
    },
    contactUs: {
        id: 'portal.views.home-page-layout.ContactUs',
        defaultMessage: 'Contact Us'
    },
    myClaims: {
        id: 'portal.views.home-page-layout.MyClaims',
        defaultMessage: 'My Claims'
    },
    myBilling: {
        id: 'portal.views.home-page-layout.MyBilling',
        defaultMessage: 'My Billing'
    },
    type: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.type',
        defaultMessage: 'Type'
    },
    statusActive: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Active',
        defaultMessage: 'Active'
    },
    statusRenewed: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Renewed',
        defaultMessage: 'Renewed'
    },
    status: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.status',
        defaultMessage: 'Status'
    },
    policy: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.policy',
        defaultMessage: 'Policy'
    },
    effective: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.effective',
        defaultMessage: 'Effective Period'
    },
    premium: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.premium',
        defaultMessage: 'Premium'
    },
    myQuickLinks: {
        id: 'portal.views.home-page-layout.My Quick Links',
        defaultMessage: 'My Quick Links'
    },
    printanIDCard: {
        id: 'portal.views.home-page-layout.Print an ID Card',
        defaultMessage: 'Print an ID Card'
    },
    makeAPayment: {
        id: 'portal.views.home-page-layout.Make a Payment',
        defaultMessage: 'Make a Payment'
    },
    setupAutomaticPayments: {
        id: 'portal.views.home-page-layout.Setup Automatic Payments',
        defaultMessage: 'Setup Automatic Payments'
    },
    changeMyPolicy: {
        id: 'portal.views.home-page-layout.ChangeMyPolicy',
        defaultMessage: 'Change My Policy'
    },
    fileClaim: {
        id: 'portal.views.home-page-layout.FileClaim',
        defaultMessage: 'Make a Claim'
    },
    getAPersonalAutoQuote: {
        id: 'portal.views.home-page-layout.Get a Personal Auto Quote',
        defaultMessage: 'Get a Personal Auto Quote'
    },
    getAHomeOwnersQuote: {
        id: 'portal.views.home-page-layout.Get a Home Owners Quote',
        defaultMessage: 'Get a Home Owners Quote'
    },
    policyDetailsAgent: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.agent',
        defaultMessage: 'Agent'
    },
    policyDetailsTel: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.tel',
        defaultMessage: 'T.'
    },
    policyDetailsIdCard: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.id card',
        defaultMessage: 'ID Card'
    },
    policyDetailsFileClaim: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.fileClaim',
        defaultMessage: 'Make a Claim'
    },
    myBalanceTileCurrent: {
        id: 'portal.directives.templates.billing-summary-tiles.Current',
        defaultMessage: 'Current'
    },
    policyNotShowing: {
        id: 'portal.views.home-page-layout.Do you have a policy with us but it is not showing?',
        defaultMessage: 'Do you have a policy with us but it is not showing?'
    },
    addPolicy: {
        id: 'portal.views.home-page-layout.Add Policy',
        defaultMessage: 'Add Policy'
    },
    addExistingPolicy: {
        id: 'portal.views.home-page-layout.Add Existing Policy',
        defaultMessage: '  Add Existing Policy'
    },
    allClaims: {
        id: 'claim.views.dashboard.claims-list.All Claims',
        defaultMessage: 'All Claims'
    },
    claimStatus: {
        id: 'claim.views.dashboard.claims-list.Status',
        defaultMessage: 'Status'
    },
    details: {
        id: 'claim.views.dashboard.claims-list.Details',
        defaultMessage: 'Details'
    },
    policyType: {
        id: 'portal.views.home-page-layout.PolicyType',
        defaultMessage: 'Policy Type'
    },

    welcome: {
        id: 'portal.views.home-page-layout.welcome',
        defaultMessage: 'Welcome'
    },
    accessDetails: {
        id: 'portal.views.home-page-layout.Here you can access your account details',
        // defaultMessage: 'Sample message, to be replaced with actual wordings'
        defaultMessage: 'Here, you access your account, view policy details, submit a claim and more.'
    },
    tweetEy: {
        id: 'portal.views.home-page-layout.tweet hfm',
        defaultMessage: '@Heartland Mutual'
        // defaultMessage: '@EYCanada'
    },
    balanceDu: {
        id: 'policy.common.directives.templates.billing-details.balanceDue',
        defaultMessage: 'Balance Due'
    },
    lastPaymentDate: {
        id: 'policy.common.directives.templates.billing-details.lastPaymentDate',
        defaultMessage: 'Last Payment Date'
    },
    lastBillingPayment: {
        id: 'policy.common.directives.templates.billing-details.lastPayment',
        defaultMessage: 'Last Payment'
    },
    billingPlan: {
        id: 'policy.common.directives.templates.billing-details.billingPlan',
        defaultMessage: 'Billing Plan'
    },
    phone: {
        id: 'common.templates.Phone',
        defaultMessage: 'Phone: {phoneNo}'
    },
    needHelpText: {
        id: 'policy.common.directives.templates.Need help? Contact us by phone',
        defaultMessage: 'Need help? Contact us by phone'
    },
    generalEnquiries: {
        id: 'policy.common.directives.templates.General Inquiries',
        defaultMessage: 'General Inquiries'
    },
    technicalEnquiries: {
        id: 'policy.common.directives.templates.Technical Enquiries for Optim',
        defaultMessage: 'Technical Enquiries for Optim'
    },
    takeMeToBtnMsg: {
        id: 'policy.common.directives.templates.Take Me to Digital Pink Slip',
        defaultMessage: 'Take Me to Digital Pink Slip'
    },
    contactUsEmailHeader:{
        id: 'policy.common.directives.templates.Need Help With A Claim?',
        defaultMessage: 'Need Help With A Claim?'
    },
    contactUsOptimEmailHeader:{
        id: 'policy.common.directives.templates.Need Help With Optim?',
        defaultMessage: 'Need Help With Optim?'
    },
    contactUsBillingEmailHeader:{
        id: 'policy.common.directives.templates.Need Help With Your Billings?',
        defaultMessage: 'Need Help With Your Billings?'
    },
    brokerContainerTitle:{
        id: 'policy.common.directives.templates.Your Advisor/Broker Contact',
        defaultMessage: 'Your Advisor/Broker Contact'
    },
    na: {
        id: 'policy.common.directives.templates.Not available',
        defaultMessage: 'Not available'
    },
    policyCustomerText:{
        id: "portal.views.home-page-layout.Policy Customer Text",
        defaultMessage: "To make changes to your policies related to coverages such as adding or removing a vehicle to an auto policy or modifying coverage on a property policy, you must contact your Agent or Broker.",
    },
    policyNextPaymentLabel: {
        id: 'portal.views.home-page-layout.NextPayment',
        defaultMessage: 'Next Payment',
    },
    paymentNotification:{
        id: "portal.views.home-page-layout.One or more policies are past due. To avoid cancellation, please make the required payment.",
        defaultMessage: "One or more policies are past due. To avoid cancellation, please make the required payment."
    }
});
